import { Component, input, computed } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReferredOutItemComponent } from './sh-referred-out-item.component';
import { ReferredOutTarget } from './sh-referred-out.model';

@Component({
    selector: 'sh-referred-out',
    templateUrl: './sh-referred-out.component.html',
    standalone: true,
    imports: [ReferredOutItemComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReferredOutComponent {
    // Legacy single-referral inputs, kept for backwards compatibility.
    public referredOutEmail = input<string>();
    public referredOutTeam = input<string>();
    public isInternalReferral = input<boolean>();

    /** When provided, every referral is rendered. Takes precedence over the single inputs. */
    public referrals = input<ReferredOutTarget[]>();

    protected readonly targets = computed<ReferredOutTarget[]>(() => {
        const list = this.referrals();
        if (list && list.length > 0) {
            return list.filter((r) => r.referredOutEmail || r.referredOutTeam);
        }

        if (this.referredOutEmail() || this.referredOutTeam()) {
            return [
                {
                    referredOutEmail: this.referredOutEmail(),
                    referredOutTeam: this.referredOutTeam(),
                    isInternalReferredOut: this.isInternalReferral()
                }
            ];
        }

        return [];
    });
}
